export const locale = {
  lang: 'fr',
  data: {
    MENU: {
      DASHBOARD: {
        COLLAPSIBLE: 'Tableaux de bord',
        BADGE: '2',
        ANALYTICS: 'Analytique',
        ECOMMERCE: 'commerce électronique',
        USER: 'User'
      },
      APPS: {
        SECTION: 'Applications et pages',
        EMAIL: 'E-mail',
        CHAT: 'Discuter',
        TODO: 'À faire',
        CALENDAR: 'Calendrier',
        INVOICE: {
          COLLAPSIBLE: "Facture d'achat",
          LIST: 'Lister',
          PREVIEW: 'Aperçu',
          EDIT: 'Éditer',
          ADD: 'Ajouter'
        },
        ECOMMERCE: {
          COLLAPSIBLE: 'commerce électronique',
          SHOP: 'Magasin',
          DETAIL: 'Des détails',
          WISHLIST: 'Liste de souhaits',
          CHECKOUT: 'Vérifier'
        },
        USER: {
          COLLAPSIBLE: 'Utilisateur',
          LIST: 'Lister',
          VIEW: 'Vue',
          EDIT: 'Éditer'
        }
      },
      PAGES: {
        SECTION: 'Des pages',
        AUTH: {
          COLLAPSIBLE: 'Authentification',
          LOGIN1: 'Connexion V1',
          LOGIN2: 'Connexion V2',
          REGISTER1: 'Enregistrer V1',
          REGISTER2: "S'inscrire V2",
          FORGOTPASSWORD1: 'Mot de passe oublié V1',
          FORGOTPASSWORD2: 'Mot de passe oublié V2',
          RESETPASSWORD1: 'Réinitialiser le mot de passe V1',
          RESETPASSWORD2: 'Réinitialiser le mot de passe V2'
        },
        ACCOUNTSETTINGS: 'Paramètres du compte',
        PROFILE: 'Profil',
        FAQ: 'FAQ',
        KB: 'Base de connaissances',
        PRICING: 'Tarification',
        BLOG: {
          COLLAPSIBLE: 'Blog',
          LIST: 'Lister',
          DETAILS: 'Des détails',
          EDIT: 'Éditer'
        },
        MAIL: {
          COLLAPSIBLE: 'Modèle de courrier',
          WELCOME: 'Bienvenue',
          RESET: 'réinitialiser le mot de passe',
          VERIFY: 'Vérifier',
          DEACTIVATE: 'Désactiver',
          INVOICE: "Facture d'achat",
          PROMOTIONAL: 'Promotionnel'
        },
        MISC: {
          COLLAPSIBLE: 'Divers',
          COMINGSOON: 'Arrive bientôt',
          NOTAUTH: 'Pas autorisé',
          MAINTENANCE: 'Maintenance',
          ERROR: 'Erreur'
        }
      },
      UI: {
        SECTION: 'Interface utilisateur',
        TYPOGRAPHY: 'Typographie',
        COLORS: 'Couleurs',
        FEATHER: 'Plume',
        CARDS: {
          COLLAPSIBLE: 'Cartes',
          BADGE: 'Nouveau',
          BASIC: 'De base',
          ADVANCE: 'Avance',
          STATISTICS: 'Statistiques',
          ANALYTICS: 'Analytique',
          ACTIONS: 'Actions'
        },
        COMPONENTS: {
          COLLAPSIBLE: 'Composants',
          ALERTS: 'Alertes',
          AVATAR: 'Avatar',
          BADGES: 'Badges',
          BREADCRUMBS: 'Chapelure',
          BUTTONS: 'Boutons',
          CAROUSEL: 'Carrousel',
          COLLAPSE: "S'effondrer",
          DIVIDER: 'Diviseur',
          DROPDOWNS: 'Listes déroulantes',
          GROUP: 'Groupe de listes',
          OBJECTS: 'Objets multimédias',
          MODALS: 'Modaux',
          COMPONENT: 'Navs',
          PAGINATION: 'Pagination',
          PBADGES: 'Badges de pilules',
          PILLS: 'Pilules',
          POPOVERS: 'popovers',
          PROGRESS: 'Le progrès',
          RATINGS: 'Évaluations',
          SPINNER: 'Fileur',
          TABS: 'Onglets',
          TIMELINE: 'Chronologie',
          TOASTS: 'Toasts',
          TOOLTIPS: 'Info-bulles'
        },
        EX: {
          COLLAPSIBLE: 'Extension',
          SWEET_ALERTS: 'Alertes douces',
          BLOCKUI: 'BlockUI',
          TOASTER: 'Toastr',
          SLIDER: 'Glissière',
          DRAGDROP: 'Glisser-déposer',
          TOUR: 'Tour',
          CLIPBOARD: 'Presse-papiers',
          MEDIAPLAYER: 'Lecteur multimédia',
          CONTEXTMENU: 'Menu contextuel',
          SWIPER: 'Swiper',
          TREEVIEW: 'Vue arborescente',
          I18N: 'I18n'
        },
        LAYOUTS: {
          COLLAPSIBLE: 'Mises en page',
          COLLAPSED_MENU: 'Menu réduit',
          BOXED_LAYOUT: 'Disposition encadrée',
          WITHOUT_MENU: 'Sans menu',
          LAYOUT_EMPTY: 'Disposition vide',
          LAYOUT_BLANK: 'Mise en page vierge'
        }
      },
      FT: {
        SECTION: 'Formulaires et tableaux',
        ELEMENT: {
          COLLAPSIBLE: 'Éléments de formulaire',
          INPUT: 'Saisir',
          INPUTGROUPS: "Groupes d'entrée",
          INPUTMASK: 'Masque de saisie',
          TEXTAREA: 'Textarea',
          CHECKBOX: 'Case à cocher',
          RADIO: 'Radio',
          SWITCH: 'Changer',
          SELECT: 'Sélectionner',
          NUMBERINPUT: 'Entrée numérique',
          FILEUPLOADER: 'Téléchargeur de fichiers',
          QUILLEDITOR: 'Éditeur de plumes',
          FLATPICKER: 'Flatpicker',
          DATETIMEPICKER: "Sélecteur de date et d'heure"
        },
        LAYOUTS: 'Dispositions de formulaire',
        WIZARD: 'Assistant de formulaire',
        VALIDATION: 'Validations de formulaire',
        REPEATER: 'Répéteur de formulaire',
        TABLE: 'Table',
        DATATABLES: 'DataTables'
      },
      CM: {
        SECTION: 'Graphiques et cartes',
        CHARTS: {
          COLLAPSIBLE: 'Graphiques',
          BADGE: '2',
          APEX: 'Sommet',
          CHARTJS: 'GraphiqueJS'
        },
        MAPS: 'Google Maps'
      },
      OTHERS: {
        SECTION: 'Autres',
        LEVELS: {
          COLLAPSIBLE: 'Niveaux de menu',
          SECOND: 'Deuxième niveau',
          SECOND1: {
            COLLAPSIBLE: 'Deuxième niveau',
            THIRD: 'Troisième niveau',
            THIRD1: 'Troisième niveau'
          }
        },
        DISABLED: 'Menu désactivé',
        DOCUMENTATION: 'Documentation',
        SUPPORT: 'Augmenter le soutien'
      }
    }
  }
};
